export default "__VITE_ASSET__BGSl4$FF__"